import { makeAutoObservable, runInAction } from "mobx";
import RootStore from "../../../stores/RootStore";

export default class MoldEngineerAssignmentStore {
    // Observables
    isLoading = false;
    error: string | null = null;
    assignments: any[] = [];
    engineers: any[] = [];
    currentAssignment: any = null;

    // Constructor
    constructor(private rootStore: RootStore) {
        makeAutoObservable(this);
    }

    // Actions
    setLoading(loading: boolean) {
        this.isLoading = loading;
    }

    setError(error: string | null) {
        this.error = error;
    }

    // Async actions
    async loadAssignments(assignmentId?: string) {
        try {
            this.setLoading(true);
            this.setError(null);

            // Mock data for now
            const mockAssignments = [
                {
                    id: "assignment-1",
                    moldId: "MOLD-001",
                    engineerId: "engineer-1",
                    engineerName: "John Smith",
                    projectName: "Office Building A",
                    assignedDate: "2024-07-01",
                    status: "In Progress",
                },
                {
                    id: "assignment-2",
                    moldId: "MOLD-002",
                    engineerId: "engineer-2",
                    engineerName: "Jane Doe",
                    projectName: "Residential Complex B",
                    assignedDate: "2024-07-03",
                    status: "Completed",
                },
            ];

            const mockEngineers = [
                {
                    id: "engineer-1",
                    name: "John Smith",
                    specialization: "Precast Molds",
                    workload: 75,
                },
                {
                    id: "engineer-2",
                    name: "Jane Doe",
                    specialization: "Complex Geometries",
                    workload: 60,
                },
            ];

            runInAction(() => {
                this.assignments = mockAssignments;
                this.engineers = mockEngineers;
                if (assignmentId) {
                    this.currentAssignment = mockAssignments.find(a => a.id === assignmentId) || null;
                }
            });
        } catch (error: any) {
            runInAction(() => {
                this.setError(error.message || "Failed to load assignments");
            });
        } finally {
            this.setLoading(false);
        }
    }

    // Computed values
    get activeAssignments() {
        return this.assignments.filter(assignment => assignment.status === "In Progress");
    }

    get availableEngineers() {
        return this.engineers.filter(engineer => engineer.workload < 80);
    }
}
